import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte,
    AangifteRapport,
    Adres,
    BokkzAlgDataService,
    BokkzIbDataService, Box3InkomenUitSparenEnBeleggen,
    IncomeTaxEntity, LeningGeldVerstrekker, OgBerekendeWaarde,
    OnroerendeZaak,
    OpbouwBox3,
    OpbouwOwr,
    SpecificatieBox3,
    SpecificatieOWR,
    VerhuurdOfVerpacht,
    VerhuurdOfVerpachtStatus
} from '@snelstart-ventures/fiscaal/domain-logic';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { optionsLandcodesMetNLD } from '../../gedeelde-componenten/gedeelde-componenten.component';
import { filter, Subscription } from 'rxjs';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiTooltipModule } from '@snelstart/ui-tooltip';
import { CommonModule } from '@angular/common';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { SharedUiCardModule } from '@snelstart/ui-card';
import { SharedUiIconModule } from '@snelstart/ui-icon';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-box3-overige-onroerende-zaken',
    templateUrl: './box3-overige-onroerende-zaken.component.html',
    styleUrls: ['./box3-overige-onroerende-zaken.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiDetailsModule,
        SharedUiDialogModule,
        SharedUiButtonModule,
        SharedUiTooltipModule,
        CommonModule,
        SharedUiAlertModule,
        SharedUiCardModule,
        SharedUiIconModule
    ]
})
export class Box3OverigeOnroerendeZakenComponent implements OnInit, OnDestroy {

    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private rapportSubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    private isUpdatingForm = false;

    public incomeTaxEntity = {} as IncomeTaxEntity;
    rapport = {} as AangifteRapport;
    private focusedElementId: string | null = null;
    public jaar = 2024;

    public dialogGegevensVisible = false;
    public dialogOwrVisible = false;
    heeftOWR: boolean[] = [];

    activeHelp: string | null = null;

    specOWRFormGroup = this.fb.group<AangifteRapport>({});
    specOWR = {} as AangifteRapport;
    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        { value: false, label: 'Nee' },
        { value: true, label: 'Ja' }
    ];

    public optionsJaNeeWoning: SelectFormControlItem<boolean | undefined>[] = [
        { value: true, label: 'Ja, betreft een woning' },
        { value: false, label: 'Nee, betreft een andere onroerende zaak' }
    ];

    public verhuurdOfVerpachtStatus: SelectFormControlItem<string | undefined>[] = [
        { value: VerhuurdOfVerpachtStatus.VERHUURD, label: 'Verhuurde woning' },
        { value: VerhuurdOfVerpachtStatus.VERPACHT, label: 'Verpachte woning' }
    ];

    public optionsJaNeeVerhuurZelfstandigDeel: SelectFormControlItem<boolean | undefined>[] = [
        { value: false, label: 'Ja, verhuur betreft gehele woning' },
        { value: true, label: 'Nee, verhuur betreft zelfstandig deel' }
    ];

    public optionsJaNeeHuurbescherming: SelectFormControlItem<boolean | undefined>[] = [
        { value: true, label: 'Ja, recht op huurbescherming' },
        { value: false, label: 'Nee, geen recht op huurbescherming' }
    ];

    public optionsJaNeeOnzakelijkeHuur: SelectFormControlItem<boolean | undefined>[] = [
        { value: false, label: 'Verhuur aan een derde' },
        { value: true, label: 'Verhuur aan een gelieerde' }
    ];

    public optionsJaNeePachtZelfstandigDeel: SelectFormControlItem<boolean | undefined>[] = [
        { value: false, label: 'Ja, pacht betreft gehele woning' },
        { value: true, label: 'Nee, pacht betreft zelfstandig deel' }
    ];
    public optionsJaNeeOvereenkomst: SelectFormControlItem<boolean | undefined>[] = [
        { value: true, label: 'Ja, minimaal 12 jaar' },
        { value: false, label: 'Nee, korter dan 12 jaar' }
    ];

    public optionsJaNeeOnzakelijkePacht: SelectFormControlItem<boolean | undefined>[] = [
        { value: false, label: 'Ja, pacht is zakelijk' },
        { value: true, label: 'Nee, pacht is niet zakelijk' }
    ];

    showDialogGegevens(index: number) {
        this.index = index;
        this.dialogGegevensVisible = true;
    }

    showDialogOwr(index: number) {
        this.index = index;
        this.dialogOwrVisible = true;
    }

    public index = 0;

    public optionsLandcodes: SelectFormControlItem<string>[] = optionsLandcodesMetNLD;

    public overigeOnroerendeZaken = {} as FormGroup;
    public rapportFormGroup = {} as FormGroup;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.overigeOnroerendeZaken = this.fb.group({
            box3OverigeOnroerendeZaken:
                this.fb.array<Box3InkomenUitSparenEnBeleggen>([])
        });
        this.rapportFormGroup = this.fb.group<AangifteRapport>(({
            specificatieBox3: this.fb.group<SpecificatieBox3>(({
                opbouw: this.fb.group<OpbouwBox3>(({
                    waardePerOGNederland: this.fb.array<OgBerekendeWaarde>([]),
                    waardePerOGBuitenland: this.fb.array<OgBerekendeWaarde>([])
                }))
            }))
        }));
        this.specOWRFormGroup = this.fb.group<AangifteRapport>(({
            specificatieOwr: this.fb.group<SpecificatieOWR>(({
                opbouw: this.fb.group<OpbouwOwr>({
                    rendementOnroerendeZakenNl: null as unknown as number,
                    rendementOnroerendeZakenBtl: null as unknown as number
                })
            }))
        }));
    }

    get box3OverigeOnroerendeZaken(): FormArray {
        return this.overigeOnroerendeZaken.get('box3OverigeOnroerendeZaken') as FormArray;
    }

    addRijOverigeOnroerendeZaken(): void {
        this.box3OverigeOnroerendeZaken.push(this.createOverigeOnroerendeZakenFormGroup()
        );
    }

    verwijderRijOverigeOnroerendeZaken(index: number): void {
        this.box3OverigeOnroerendeZaken.removeAt(index);
        this.overigeOnroerendeZaken.updateValueAndValidity();
        this.overigeOnroerendeZaken.markAsDirty();
        this.saveForm();
    }


    createOverigeOnroerendeZakenFormGroup(oz?: OnroerendeZaak): FormGroup {
        return this.fb.group({
            adres: this.createAdresFormGroup(oz?.adres),
            woz: oz?.woz ?? undefined,
            wozPlusEen: oz?.wozPlusEen ?? undefined,
            percentageEigendom: oz?.percentageEigendom ?? 100.00,
            betaaldeErfpachtCanon: oz?.betaaldeErfpachtCanon ?? undefined,
            betaaldeErfpachtCanonEindeJaar: oz?.betaaldeErfpachtCanonEindeJaar ?? undefined,
            datumGekocht: oz?.datumGekocht ?? undefined,
            datumVerkocht: oz?.datumVerkocht ?? undefined,
            investeringen: oz?.investeringen ?? undefined,
            waardestijgingWOZwaardeWegensInvesteringen: oz?.waardestijgingWOZwaardeWegensInvesteringen ?? undefined,
            woning: oz?.woning ?? undefined,
            directRendement: oz?.directRendement ?? undefined,
            verhuurdOfVerpacht: this.createVerhuurdOfVerpachtFormGroup(oz?.verhuurdOfVerpacht),
            verhuurdOfVerpachtOpEinddatum: this.createVerhuurdOfVerpachtFormGroup(oz?.verhuurdOfVerpachtOpEinddatum)
        }) as FormGroup;
    }

    private createVerhuurdOfVerpachtFormGroup(vov?: VerhuurdOfVerpacht): FormGroup {
        return this.fb.group({
            status: vov?.status ?? undefined,
            overeenkomstMeerDan12Jaar: vov?.overeenkomstMeerDan12Jaar ?? undefined,
            jaarpacht: vov?.jaarpacht ?? undefined,
            onzakelijkePacht: vov?.onzakelijkePacht ?? undefined,
            huurbescherming: vov?.huurbescherming ?? undefined,
            jaarhuur: vov?.jaarhuur ?? undefined,
            onzakelijkeHuur: vov?.onzakelijkeHuur ?? undefined,
            zelfstandigDeelVanGroterGebouw: vov?.zelfstandigDeelVanGroterGebouw ?? undefined,
            percentageVerhuurd: vov?.percentageVerhuurd ?? 100,
            directRendement: vov?.directRendement ?? undefined
        } as unknown as VerhuurdOfVerpacht);
    }

    ensureVerhuurdOfVerpacht(index: number): void {
        const ozGroup = this.box3OverigeOnroerendeZaken.at(index) as FormGroup;
        if (!ozGroup.get('verhuurdOfVerpacht')) {
            ozGroup.addControl('verhuurdOfVerpacht', this.createVerhuurdOfVerpachtFormGroup());
        }
    }

    ensureVerhuurdOfVerpachtOpEinddatum(index: number): void {
        const ozGroup = this.box3OverigeOnroerendeZaken.at(index) as FormGroup;
        if (!ozGroup.get('verhuurdOfVerpachtOpEinddatum')) {
            ozGroup.addControl('verhuurdOfVerpachtOpEinddatum', this.createVerhuurdOfVerpachtFormGroup());
        }
    }

    public createAdresFormGroup(adres?: Adres) {
        return this.fb.group({
            straat: adres?.straat ?? undefined,
            huisNummer: adres?.huisNummer ?? undefined,
            huisNummerToevoeging: adres?.huisNummerToevoeging ?? undefined,
            postcode: adres?.postcode ?? undefined,
            woonplaats: adres?.woonplaats ?? undefined,
            landCode: adres?.landCode ?? 'NLD'
        } as Adres);
    }

    public verwijderLetters(input: string): string {
        return input.replace(/\D/g, '');
    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.updateForm();
                this.updateHeeftOWR();
            }
            if (incomeTaxEntity.year !== undefined) {
                this.jaar = incomeTaxEntity.year;
            }
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });
        this.rapportSubscription = this.dataService.aangifteRapport.subscribe((rapport) => {
            this.dataService.aangifteRapport.subscribe((value) => {
                this.specOWRFormGroup.reset();
                this.specOWR = value;
                this.specOWRFormGroup.patchValue(this.specOWR);
            });
            this.rapport = rapport;
            if (rapport) {
                this.rapportFormGroup.patchValue({
                    specificatieOwr: {
                        opbouw: {
                            rendementOnroerendeZakenNl: rapport.specificatieOWR?.opbouw?.rendementOnroerendeZakenNl,
                            rendementOnroerendeZakenBtl: rapport.specificatieOWR?.opbouw?.rendementOnroerendeZakenBtl
                        }
                    }
                });
            }
        });
        this.routerSubscription = this.router.events
            .pipe(
                filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.rapportSubscription) {
            this.rapportSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.overigeOnroerendeZaken.dirty;
    }

    private updateForm(): void {
        this.isUpdatingForm = true;
        const onroerendeZakenLijst = this.incomeTaxEntity?.aangifte?.box3?.overigeOnroerendeZaken || [];
        const formArray = this.overigeOnroerendeZaken.get('box3OverigeOnroerendeZaken') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > onroerendeZakenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < onroerendeZakenLijst.length; i++) {
            const onrZaak = onroerendeZakenLijst[i];
            if (onrZaak.adres?.landCode === 'NLD' && onrZaak.adres?.postcode) {
                onrZaak.adres.postcode = this.formatPostcode(onrZaak.adres.postcode);
            }

            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(onroerendeZakenLijst[i], { emitEvent: false });
            } else {
                const formGroup = this.createOverigeOnroerendeZakenFormGroup(onroerendeZakenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
        this.isUpdatingForm = false;
    }

    resetVerhuurdOfVerpacht(index: number): void {
        const group = this.box3OverigeOnroerendeZaken.at(index).get('verhuurdOfVerpacht') as FormGroup;
        group.reset();
        this.saveForm();
    }

    resetVerhuurdOfVerpachtOpEinddatum(index: number): void {
        const group = this.box3OverigeOnroerendeZaken.at(index).get('verhuurdOfVerpachtOpEinddatum') as FormGroup;
        group.reset();
        this.saveForm();
    }


    saveForm(): void {
        if (this.isUpdatingForm) return;
        this.overigeOnroerendeZaken.updateValueAndValidity();
        setTimeout(() => {
            const updatedOnroerendeZakenLijst = this.overigeOnroerendeZaken.value.box3OverigeOnroerendeZaken.map((oz: OnroerendeZaak, index: number) => {
                const adres = oz.adres;
                const landCode = adres?.landCode;
                const postcode = adres?.postcode ?? '1111';
                const huisnr = adres?.huisNummer ?? '2222';
                const woz = oz.woz ?? '3333';
                let woznummerValue = [index, postcode, huisnr, woz].map(String).join('');
                woznummerValue = woznummerValue.replace(/\D/g, '');
                woznummerValue = woznummerValue.slice(0, 12).padStart(12, '0');
                // Reset jaarhuur als onzakelijke huur
                const jaarhuur = oz.verhuurdOfVerpacht?.onzakelijkeHuur ? null : oz.verhuurdOfVerpacht?.jaarhuur;
                const jaarhuurOpEindDatum = oz.verhuurdOfVerpachtOpEinddatum?.onzakelijkeHuur ? null : oz.verhuurdOfVerpachtOpEinddatum?.jaarhuur;

                //Reset WOZ-verhoging als investering is null
                const waardestijgingWOZwaardeWegensInvesteringen = oz.investeringen != null
                    ? oz.waardestijgingWOZwaardeWegensInvesteringen
                    : null;

                // Reset alles als geen huur/pacht OF niet NLD OF geen woning
                const verhuurdOfVerpacht = oz.verhuurdOfVerpacht?.status ? oz.verhuurdOfVerpacht : null;
                const verhuurdOfVerpachtOpEinddatum = oz.verhuurdOfVerpachtOpEinddatum?.status
                    ? oz.verhuurdOfVerpachtOpEinddatum
                    : null;

                // Reset oz.directRendement als verhuurdOfVerpacht.directRendement > 0
                const directRendement =
                    ((oz.verhuurdOfVerpacht?.directRendement != undefined && oz.verhuurdOfVerpacht?.directRendement > 0) ||
                        (oz.verhuurdOfVerpachtOpEinddatum?.directRendement != undefined && oz.verhuurdOfVerpachtOpEinddatum?.directRendement > 0))
                        ? null
                        : oz.directRendement;
                // Verwijder verhuurdOfVerpacht uit oz zodat het niet via spread meegaat
                const { verhuurdOfVerpacht: _ignored, verhuurdOfVerpachtOpEinddatum: _ignored2, ...ozRest } = oz;

                return {
                    ...ozRest,
                    woznummer: woznummerValue,
                    waardestijgingWOZwaardeWegensInvesteringen: waardestijgingWOZwaardeWegensInvesteringen,
                    directRendement,
                    verhuurdOfVerpacht,
                    verhuurdOfVerpachtOpEinddatum
                };
            });

            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity?.aangifte,
                box3: {
                    ...this.incomeTaxEntity?.aangifte?.box3,
                    overigeOnroerendeZaken: updatedOnroerendeZakenLijst
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            this.updateHeeftOWR();
        }, 0);
    }

    formatPostcode(postcode: string | null | undefined): string {
        if (!postcode) return '';
        const cleanedPostcode = postcode.replace(/[^a-zA-Z0-9]/g, '');
        if (cleanedPostcode.length >= 4) {
            const cijfers = cleanedPostcode.substring(0, 4).replace(/\D/g, ''); // Alleen cijfers
            const letters = cleanedPostcode.substring(4, 6).replace(/[^a-zA-Z]/g, '').toUpperCase(); // Alleen letters
            return `${cijfers}${letters}`;
        }

        return cleanedPostcode;
    }

    protected readonly VerhuurdOfVerpachtStatus = VerhuurdOfVerpachtStatus;
    protected readonly LeningGeldVerstrekker = LeningGeldVerstrekker;

    updateHeeftOWR(): void {
        this.heeftOWR = this.box3OverigeOnroerendeZaken.controls.map((item) => {
            const velden = ['waardeEindJaar', 'directRendement', 'valutaResultaat', 'toenames', 'afnames'];
            return velden.some(veld => item?.get(veld)?.value);
        });
    }


    getOWRDialogTitel(i: number): string {
        const postcode = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.postcode')?.value;
        const huisNummer = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.huisNummer')?.value;
        const toevoeging = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.huisNummerToevoeging')?.value;
        const woonplaats = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.woonplaats')?.value;

        if (!postcode || !huisNummer) {
            return 'Werkelijk rendement onroerende zaak';
        }

        return `Werkelijk rendement onroerende zaak: ${postcode} ${huisNummer}${toevoeging ? ' ' + toevoeging : ''}${woonplaats ? ', ' + woonplaats : ''}`;
    }

    getGegevensDialogTitel(i: number): string {
        const postcode = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.postcode')?.value;
        const huisNummer = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.huisNummer')?.value;
        const toevoeging = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.huisNummerToevoeging')?.value;
        const woonplaats = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.woonplaats')?.value;
        if (!postcode || !huisNummer) {
            return 'Gegevens onroerende zaak';
        }

        return `Gegevens onroerende zaak: ${postcode} ${huisNummer}${toevoeging ? ' ' + toevoeging : ''}${woonplaats ? ', ' + woonplaats : ''}`;
    }

    getWozLabel(i: number): string {
        const woning = this.box3OverigeOnroerendeZaken.controls[i]?.get('woning')?.value;
        const landCode = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.landCode')?.value;

        if (woning === true && landCode === 'NLD') {
            return `WOZ-waarde ${this.jaar} (peildatum 1-1-${this.jaar - 1})`;
        }
        if (woning === true) {
            return `Waarde vrij opleverbaar 1-1-${this.jaar - 1}`;
        }
        return `Waarde economisch verkeer ${this.getDatumBegin(i)}`;
    }

    getWozLabelEind(i: number): string {
        const woning = this.box3OverigeOnroerendeZaken.controls[i]?.get('woning')?.value;
        const landCode = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.landCode')?.value;

        if (woning === true && landCode === 'NLD') {
            return `WOZ-waarde ${this.jaar + 1} (peildatum 1-1-${this.jaar})`;
        }
        if (woning === true) {
            return `Waarde vrij opleverbaar 1-1-${this.jaar}`;
        }
        return `Waarde economisch verkeer ${this.getDatumEind(i)}`;
    }

    getBerekendeWaardeBegin(i: number): number | null {
        const postcode = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.postcode')?.value;
        const huisNummer = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.huisNummer')?.value;
        const woonplaats = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.woonplaats')?.value;
        const landCode = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.landCode')?.value;

        if (!postcode || !huisNummer || !woonplaats) return null;

        const opbouw = this.rapport?.specificatieBox3?.opbouw;
        const lijst = landCode === 'NLD' ? opbouw?.['waardePerOGNederland'] : opbouw?.['waardePerOGBuitenland'];

        const match = lijst?.find((og: OgBerekendeWaarde) =>
            og.adres?.postcode === postcode &&
            og.adres?.huisNummer === huisNummer &&
            og.adres?.woonplaats === woonplaats
        );

        return match?.berekendeWaarde ?? null;
    }

    getBerekendeWaardeEind(i: number): number | null {
        const postcode = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.postcode')?.value;
        const huisNummer = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.huisNummer')?.value;
        const woonplaats = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.woonplaats')?.value;
        const landCode = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.landCode')?.value;

        if (!postcode || !huisNummer || !woonplaats) return null;

        const opbouw = this.rapport?.specificatieBox3?.opbouw;
        const lijst = landCode === 'NLD' ? opbouw?.['waardePerOGNederland'] : opbouw?.['waardePerOGBuitenland'];

        const match = lijst?.find((og: OgBerekendeWaarde) =>
            og.adres?.postcode === postcode &&
            og.adres?.huisNummer === huisNummer &&
            og.adres?.woonplaats === woonplaats
        );

        return match?.berekendeWaardeEindDatum ?? null;
    }

    getBerekendeWerkelijkRendement(i: number): number | null {
        const postcode = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.postcode')?.value;
        const huisNummer = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.huisNummer')?.value;
        const woonplaats = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.woonplaats')?.value;
        const landCode = this.box3OverigeOnroerendeZaken.controls[i]?.get('adres.landCode')?.value;

        if (!postcode || !huisNummer || !woonplaats) return null;

        const opbouw = this.rapport?.specificatieBox3?.opbouw;
        const lijst = landCode === 'NLD' ? opbouw?.['waardePerOGNederland'] : opbouw?.['waardePerOGBuitenland'];

        const match = lijst?.find((og: OgBerekendeWaarde) =>
            og.adres?.postcode === postcode &&
            og.adres?.huisNummer === huisNummer &&
            og.adres?.woonplaats === woonplaats
        );

        return match?.werkelijkRendement ?? null;
    }


    getDatumBegin(i: number): string {
        const value = this.box3OverigeOnroerendeZaken.controls[i]?.get('datumGekocht')?.value;
        if (!value) {
            return '1-1-' + this.jaar;
        }
        const date = new Date(value);
        return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    }

    getDatumEind(i: number): string {
        const value = this.box3OverigeOnroerendeZaken.controls[i]?.get('datumVerkocht')?.value;
        if (!value) {
            return '31-12-' + this.jaar;
        }
        const date = new Date(value);
        return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    }

    showHelp(id: string): void {
        this.activeHelp = id;
    }

    hideHelp(): void {
        this.activeHelp = null;
    }

}
